// React
import { useRef, useState } from "react"

// Components
import MainCard from "../main-card"
import { Stack, Typography, CircularProgress, Box, useTheme, Grid, Button } from "@mui/material"

// Next Image
import { ArrowCircleDown2, DocumentDownload } from "iconsax-react"

// Icons
import { toast } from "react-toastify"
import { useMediaQuery } from "react-responsive"
import { Photo } from "@mui/icons-material"

// ----------------------------------------|| FILE UPLOADER - COMPONENTS ||-------------------------------------------

const FileUploader = ({ title, subTitle, setFile, sx, size = 180, description = "" }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 })

  // Use Ref
  const inputRef = useRef()

  // Use Theme
  const theme = useTheme()

  // States
  const [image, setImage] = useState()
  const [loading, setLoading] = useState(false)
  const [isPdf, setIsPdf] = useState(false)

  // Handle Change Input
  const onImageChange = e => {
    setLoading(false)

    if (e.target.files && e.target.files[0]) {
      const fileSize = e.target.files[0].size / 1024 / 1024 // in MiB

      if (fileSize <= 5) {
        let reader = new FileReader()

        reader.readAsDataURL(e.target.files[0])

        reader.onload = function () {
          setImage(URL.createObjectURL(e.target.files[0]))

          // Check the file type
          const fileType = e.target.files[0].type

          if (fileType.startsWith("image/")) {
            // It's an image
            setFile(reader.result.split(",")[1])
            setIsPdf(false)
          } else if (fileType === "application/pdf") {
            setFile(reader.result.split(",")[1])
            setIsPdf(reader.result)
          } else {
            // Unsupported file type
            toast.error("Unsupported file type.")
          }
        }
      } else {
        toast.error("حداکثر حجم مجاز فایل 5 مگابایت است.")
      }
    }
  }

  const downloadPdfFile = async () => {
    // Fetch the content of the Blob URL
    const response = await fetch(image)
    const blob = await response.blob()

    // Create a blob URL for the PDF Blob
    const blobUrl = URL.createObjectURL(blob)

    // Create a link element
    const downloadLink = document.createElement("a")

    // Set the href and download attributes
    downloadLink.href = blobUrl
    downloadLink.download = "تصویر_فایل.pdf" // You can set the desired file name here

    // Append the link to the body
    document.body.appendChild(downloadLink)

    // Simulate a click on the link to trigger the download
    downloadLink.click()

    // Remove the link from the body
    document.body.removeChild(downloadLink)

    // Release the blob URL
    URL.revokeObjectURL(blobUrl)
  }

  // Handle Open Select File
  const handleFileUpload = () => {
    if (!loading) {
      inputRef.current.click()
    } else {
      setLoading(true)
    }
  }

  return (
    <MainCard
      shadow={3}
      sx={{ borderRadius: "10px", cursor: "pointer", display: "block", minHeight: "135px", mt: 1, ...sx }}
      onClick={handleFileUpload}
    >
      <input
        ref={inputRef}
        type='file'
        hidden
        multiple
        accept={["image/jpeg", "image/png", "application/pdf"]}
        onChange={onImageChange}
      />

      {image && !loading && (
        <>
          <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", marginBottom: 1 }}>
            {/* <Button
              color='success'
              variant='contained'
              fullWidth={isMobile}
              size='medium'
              sx={{ borderRadius: "4px", px: 1, ml: 2 }}
            >
              {title.toString().substring(title?.length, 3)}
            </Button> */}

            <Button
              color='warning'
              variant='contained'
              fullWidth={isMobile}
              startIcon={<Photo />}
              size='medium'
              sx={{ borderRadius: "4px", px: 2 }}
            >
              تغییر تصویر
            </Button>
          </Box>
          {!isMobile ? (
            isPdf ? (
              <Grid display={"flex"} justifyContent={"center"} alignItems={"center"} mb={2}>
                <iframe
                  frameborder='0'
                  allowtransparency='yes'
                  scrolling='no'
                  width='70%'
                  height='500'
                  src={isPdf + "#toolbar=0"}
                />
              </Grid>
            ) : (
              <Box>
                <img src={image} className='resize_fit_center' alt='selected_img' />
              </Box>
            )
          ) : isPdf ? (
            <Stack
              direction='row'
              justifyContent='center'
              py={2}
              onClick={e => {
                e.stopPropagation() // Stop the event from propagating to the parent (handleFileUpload)
                downloadPdfFile() // Call the downloadPdfFile function
              }}
            >
              <Button size='large' startIcon={<ArrowCircleDown2 />} variant='contained' sx={{ borderRadius: "8px" }}>
                دانلود فایل آپلود شده
              </Button>
            </Stack>
          ) : (
            <Box>
              <img src={image} className='resize_fit_center' alt='selected_img' />
            </Box>
          )}
        </>
      )}

      {loading && !image && (
        <Box sx={{ py: 3 }}>
          <CircularProgress />
        </Box>
      )}
      {!image && !loading && (
        <Box sx={{ m: 0.3, borderRadius: "6px", border: `1px dashed ${theme.palette.divider}` }}>
          <Stack direction='row' justifyContent='center' alignContent='center' my={2}>
            <Stack direction='row' alignItems='center' justifyContent='center'>
              <DocumentDownload size={size} />
              <Stack ml={3}>
                <Typography variant='h5' fontWeight='bold'>
                  {title}
                </Typography>
                <Typography variant='caption' color='secondary'>
                  {subTitle}
                </Typography>
              </Stack>
            </Stack>
          </Stack>
        </Box>
      )}

      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
        <Stack>
          <Typography variant='subtitle2'>حداکثر حجم فایل ارسالی 1 مگابایت است</Typography>
          {description && (
            <Typography variant='caption' color='error' pt={2}>
              {description}
            </Typography>
          )}
        </Stack>
      </Box>
    </MainCard>
  )
}

export default FileUploader
